module.exports = ["ID","SD","UT","VT"]


//////////////////
// WEBPACK FOOTER
// ./src/components/utils/address/resources/noLendStates.json
// module id = PwT6
// module chunks = 1